<ng-container *ngIf="patent.priorityPatent && patent.priorityPatent._dynamicComponent && priorityPatentDynamicChildren.length">
	<p-panel header="{{ 'fs.res.patent.priorityPatent.dynamicComponents' | hisUi }}">
		<ng-container *ngFor="let dynamicComponentChild of priorityPatentDynamicChildren">
			<h3>{{ dynamicComponentChild.name | hisUi }}</h3>
			<div class="detailPresentationList">
				<ng-container *ngFor="let dynamicField of dynamicComponentChild.fields">
						<div class="layoutBlock detailPresentationListItem">
							<div class="columnOneThird detailPresentationListLabel">
								<span>{{ dynamicField.ddKey | hisUi }}</span>
							</div>
							<div class="columnOneThird">
								<ng-container *ngIf="dynamicFieldValueUtils.getKeyTableDatasource(dynamicObjects, dynamicField); else simpleFieldValue">
									{{ dynamicFieldValueUtils.getDynamicFieldKeyTableValue(dynamicObjects, dynamicField, keyTableFieldIdValueMap) }}
								</ng-container>
								<ng-template #simpleFieldValue>
									{{ dynamicFieldValueUtils.getDynamicFieldSimpleValue(dynamicObjects, dynamicField) }}
								</ng-template>
							</div>
						</div>
				</ng-container>
			</div>
		</ng-container>
	</p-panel>
</ng-container>
